// import { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { ArrowLeft, Shield, CheckCircle, CreditCard, Clock, Zap, Crown } from 'lucide-react';
// import StripeCheckout from '../components/StripeCheckout';
// import useStore from '../store/useStore';

// function Checkout() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { tier, amount, billingCycle } = location.state || {};
//   const { user, setAccessTier } = useStore();
//   const [loading, setLoading] = useState(false);
//   const [paymentStatus, setPaymentStatus] = useState('idle');

//   useEffect(() => {
//     if (!tier || !amount) {
//       navigate('/pricing');
//       return;
//     }

//     if (!user) {
//       localStorage.setItem('redirectPath', '/checkout');
//       localStorage.setItem('checkoutState', JSON.stringify({ tier, amount, billingCycle }));
//       navigate('/auth');
//     }
//   }, [tier, amount, billingCycle, user, navigate]);

//   // In Checkout.jsx - UPDATED handlePaymentSuccess
// const handlePaymentSuccess = async (paymentIntent) => {
//   setPaymentStatus('processing');
  
//   try {
//     const token = localStorage.getItem('token');
    
//     // Update user's access tier in backend
//     const response = await fetch('/api/v2/payments/subscribe/free', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//       body: JSON.stringify({
//         tier: tier.name,
//         // Free endpoint might not need tier, but include it anyway
//       })
//     });

//     if (response.ok) {
//       // Update store
//       setAccessTier(tier.name);
      
//       // Show success message
//       setPaymentStatus('success');
      
//       // Redirect after delay
//       setTimeout(() => {
//         navigate('/dashboard', { 
//           state: { 
//             paymentSuccess: true,
//             tier: tier.name
//           }
//         });
//       }, 2000);
//     } else {
//       // Even if backend update fails, payment succeeded
//       console.warn('Payment succeeded but backend update failed');
//       setAccessTier(tier.name); // Update store anyway
//       setPaymentStatus('success');
      
//       setTimeout(() => {
//         navigate('/dashboard', { 
//           state: { 
//             paymentSuccess: true,
//             tier: tier.name,
//             note: 'Payment processed. Please check your subscription status.'
//           }
//         });
//       }, 2000);
//     }
//   } catch (error) {
//     console.error('Error:', error);
//     // Payment succeeded even if backend update failed
//     setAccessTier(tier.name); // Update store anyway
//     setPaymentStatus('success');
    
//     setTimeout(() => {
//       navigate('/dashboard', { 
//         state: { 
//           paymentSuccess: true,
//           tier: tier.name,
//           note: 'Payment processed. Subscription update may be pending.'
//         }
//       });
//     }, 2000);
//   }
// };
//   const handlePaymentError = (error) => {
//     console.error('Payment error:', error);
//     alert(`Payment failed: ${error.message}`);
//     setPaymentStatus('error');
//   };

//   const getTierIcon = () => {
//     switch (tier?.name) {
//       case 'plus': return Zap;
//       case 'pro': return Crown;
//       default: return CreditCard;
//     }
//   };

//   const TierIcon = getTierIcon();

//   if (!tier) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <h2 className="text-2xl font-bold text-gray-900 mb-4">Invalid Checkout Session</h2>
//           <button 
//             onClick={() => navigate('/pricing')} 
//             className="px-6 py-3 bg-purple-600 text-white rounded-lg font-semibold hover:bg-purple-700"
//           >
//             Back to Pricing
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-12">
//       <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//         <button
//           onClick={() => navigate('/pricing')}
//           className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-8 group"
//         >
//           <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
//           <span>Back to Pricing</span>
//         </button>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           {/* Left Column - Order Summary */}
//           <div className="lg:col-span-2">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="bg-white rounded-2xl shadow-lg p-8 mb-6"
//             >
//               <div className="flex items-center space-x-4 mb-8">
//                 <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
//                   <TierIcon className="w-8 h-8 text-white" />
//                 </div>
//                 <div>
//                   <h1 className="text-3xl font-bold text-gray-900">{tier.display_name}</h1>
//                   <p className="text-gray-600">{tier.description}</p>
//                 </div>
//               </div>

//               {paymentStatus === 'success' ? (
//                 <div className="text-center py-12">
//                   <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                   <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment Successful! 🎉</h2>
//                   <p className="text-gray-600 mb-8">
//                     Welcome to {tier.display_name}. Redirecting to dashboard...
//                   </p>
//                   <div className="animate-pulse text-purple-600">
//                         <Clock className="w-8 h-8 mx-auto" />
//                   </div>
//                 </div>
//               ) : (
//                 <StripeCheckout
//                   tier={tier}
//                   amount={amount}
//                   billingCycle={billingCycle}
//                   onSuccess={handlePaymentSuccess}
//                   onError={handlePaymentError}
//                   onLoading={setLoading}
//                 />
//               )}
//             </motion.div>

//             <div className="bg-white rounded-2xl shadow-lg p-6">
//               <div className="flex items-center space-x-3 mb-4">
//                 <Shield className="w-6 h-6 text-green-500" />
//                 <h3 className="font-semibold text-gray-900">Secure Payment Guarantee</h3>
//               </div>
//               <ul className="space-y-3 text-sm text-gray-600">
//                 <li className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
//                   PCI DSS compliant payment processing
//                 </li>
//                 <li className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
//                   256-bit SSL encryption
//                 </li>
//                 <li className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
//                   Your card details are never stored
//                 </li>
//                 <li className="flex items-center">
//                   <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
//                   30-day money-back guarantee
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Right Column - Order Details */}
//           <div className="space-y-6">
//             <motion.div
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               className="bg-white rounded-2xl shadow-lg p-6"
//             >
//               <h2 className="text-xl font-bold text-gray-900 mb-6">Order Summary</h2>
              
//               <div className="space-y-4">
//                 <div className="flex justify-between items-center pb-4 border-b">
//                   <div>
//                     <h3 className="font-medium text-gray-900">{tier.display_name}</h3>
//                     <p className="text-sm text-gray-500 capitalize">{billingCycle} billing</p>
//                   </div>
//                   <div className="text-right">
//                     <div className="text-xl font-bold text-gray-900">R{amount}</div>
//                     <div className="text-sm text-gray-500">
//                       per {billingCycle === 'monthly' ? 'month' : 'year'}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="space-y-2">
//                   <div className="flex justify-between text-sm">
//                     <span className="text-gray-600">Subtotal</span>
//                     <span>R{amount.toFixed(2)}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span className="text-gray-600">VAT (15%)</span>
//                     <span>R{(amount * 0.15).toFixed(2)}</span>
//                   </div>
//                   <div className="flex justify-between text-lg font-bold pt-2 border-t">
//                     <span>Total</span>
//                     <span>R{(amount * 1.15).toFixed(2)}</span>
//                   </div>
//                 </div>
//               </div>

//               {tier.features && (
//                 <div className="mt-8 pt-6 border-t">
//                   <h3 className="font-semibold text-gray-900 mb-4">Features Included:</h3>
//                   <ul className="space-y-2">
//                     {tier.features
//                       .filter(f => f.included)
//                       .slice(0, 5)
//                       .map((feature, index) => (
//                         <li key={index} className="flex items-center text-sm">
//                           <CheckCircle className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" />
//                           <span className="text-gray-700">{feature.name}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 </div>
//               )}
//             </motion.div>

//             <div className="bg-blue-50 rounded-2xl p-6 border border-blue-100">
//               <h3 className="font-semibold text-blue-900 mb-3">Need help?</h3>
//               <p className="text-blue-700 text-sm mb-4">
//                 Our support team is here to help with any payment issues.
//               </p>
//               <div className="space-y-2">
//                 <a 
//                   href="mailto:support@saintsacademy.com" 
//                   className="text-blue-600 hover:text-blue-800 text-sm block"
//                 >
//                   ✉️ support@saintsacademy.com
//                 </a>
//                 <a 
//                   href="tel:+27111234567" 
//                   className="text-blue-600 hover:text-blue-800 text-sm block"
//                 >
//                   📞 +27 11 123 4567
//                 </a>
//               </div>
//             </div>

//             {loading && (
//               <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4">
//                 <p className="text-sm text-yellow-800 text-center">
//                   ⚠️ Do not refresh or close this page while payment is processing
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Checkout;


// src/pages/Checkout.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, AlertCircle, Zap, Headphones, Clock, CheckCircle } from 'lucide-react';
import { API_CONFIG, fetchAPI, subscribeToNotifications } from '../api/config';
import useStore from '../store/useStore';

function Checkout() {
  const navigate = useNavigate();
  const { user } = useStore();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationType, setNotificationType] = useState('plus');
  const [error, setError] = useState('');

  const handleNotifyMe = async (e, courseTier = 'plus') => {
    e.preventDefault();
    setNotificationType(courseTier);
    setError('');
    
    const subscribeEmail = email || user?.email;
    
    if (!subscribeEmail) {
      setError('Please enter your email address');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(subscribeEmail)) {
      setError('Please enter a valid email address');
      return;
    }

    setNotificationLoading(true);
    
    try {
      // Try the primary endpoint first
      const response = await fetch('/api/v2/admin/email-api.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'subscribe',
          email: subscribeEmail,
          name: user?.name || '',
          type: courseTier === 'pro' ? 'saints_pro' : 'saints_plus',
          tier: courseTier,
          source: 'checkout_page',
          user_id: user?.id || null,
          meta: {
            page: 'checkout',
            tier: courseTier,
            timestamp: new Date().toISOString()
          }
        })
      });

      const data = await response.json();
      
      if (data.success) {
        // Store locally as backup
        API_CONFIG.storeLocally('email_subscriptions', {
          email: subscribeEmail,
          tier: courseTier,
          source: 'checkout',
          user_id: user?.id || null
        });
        
        setSubscribed(true);
        setEmail('');
        
        setTimeout(() => {
          setSubscribed(false);
        }, 5000);
      } else {
        // If primary fails, try backup
        console.log('Primary endpoint failed, trying backup...');
        await tryCheckoutBackup(subscribeEmail, courseTier);
      }
    } catch (error) {
      console.log('Primary endpoint error, trying backup...', error);
      await tryCheckoutBackup(subscribeEmail, courseTier);
    } finally {
      setNotificationLoading(false);
    }
  };

  const tryCheckoutBackup = async (subscribeEmail, courseTier) => {
    try {
      // Try the backup endpoint
      const backupResponse = await fetch('/api/v2/admin/checkout-notify.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: subscribeEmail,
          name: user?.name || '',
          tier: courseTier,
          type: courseTier === 'pro' ? 'saints_pro' : 'saints_plus',
          user_id: user?.id || null
        })
      });
      
      const backupData = await backupResponse.json();
      
      if (backupData.success) {
        setSubscribed(true);
        setEmail('');
        
        setTimeout(() => {
          setSubscribed(false);
        }, 5000);
      } else {
        // Final fallback: Store locally
        API_CONFIG.storeLocally('email_subscriptions', {
          email: subscribeEmail,
          tier: courseTier,
          source: 'checkout_fallback',
          user_id: user?.id || null,
          timestamp: new Date().toISOString()
        });
        
        setSubscribed(true);
        setEmail('');
        
        setTimeout(() => {
          setSubscribed(false);
        }, 5000);
      }
    } catch (backupError) {
      console.error('Backup endpoint failed:', backupError);
      
      // Ultimate fallback
      API_CONFIG.storeLocally('email_subscriptions', {
        email: subscribeEmail,
        tier: courseTier,
        source: 'checkout_ultimate_fallback',
        user_id: user?.id || null,
        timestamp: new Date().toISOString()
      });
      
      setSubscribed(true);
      setEmail('');
      
      setTimeout(() => {
        setSubscribed(false);
      }, 5000);
    }
  };

  const getNotificationMessage = () => {
    if (notificationType === 'plus') {
      return 'You\'ll be notified when Saints Plus launches with premium courses, HD audio, and downloadable content.';
    } else {
      return 'You\'ll be notified when Saints Pro launches with certifications, custom learning paths, and lifetime course access.';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate('/pricing')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-8 group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          <span>Back to Pricing</span>
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Coming Soon Message */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-600 rounded-2xl p-8 md:p-12 text-white mb-8 text-center shadow-xl"
            >
              <div className="flex items-center justify-center gap-3 mb-6">
                <AlertCircle className="w-10 h-10" />
                <h1 className="text-4xl md:text-5xl font-bold">Saints Plus - Coming Soon!</h1>
              </div>
              
              <div className="mb-8">
                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-4">
                  <Zap className="w-6 h-6" />
                  <span className="text-lg font-semibold">Premium Features Under Development</span>
                </div>
                <p className="text-xl text-blue-100 mb-6 max-w-2xl mx-auto">
                  Our Saints Plus subscription is currently being prepared. Enjoy our extensive podcast library for free while we build premium courses and exclusive features.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl mx-auto">
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                  <div className="flex items-center justify-center mb-2">
                    <Headphones className="w-6 h-6" />
                  </div>
                  <p className="text-2xl font-bold">130+</p>
                  <p className="text-sm text-blue-100">Podcasts Free</p>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                  <div className="flex items-center justify-center mb-2">
                    <Clock className="w-6 h-6" />
                  </div>
                  <p className="text-2xl font-bold">Coming</p>
                  <p className="text-sm text-blue-100">Courses Soon</p>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                  <div className="flex items-center justify-center mb-2">
                    <Mail className="w-6 h-6" />
                  </div>
                  <p className="text-2xl font-bold">Notify</p>
                  <p className="text-sm text-blue-100">Get Early Access</p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Notification Form */}
          <div className="lg:col-span-1">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-2xl shadow-xl p-8"
            >
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Be First to Know</h2>
              <p className="text-gray-600 mb-6">
                Get notified when Saints Plus launches with premium courses, exclusive podcasts, and advanced features.
              </p>

              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
                  {error}
                </div>
              )}

              {subscribed ? (
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6 text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <CheckCircle className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-green-800 mb-2">
                    {notificationType === 'plus' ? 'Saints Plus Waitlist!' : 'Saints Pro Waitlist!'} 🎉
                  </h3>
                  <p className="text-green-700 mb-2">
                    {getNotificationMessage()}
                  </p>
                  <p className="text-green-600 text-sm">
                    We'll email you as soon as it's available.
                  </p>
                </div>
              ) : (
                <>
                  <form onSubmit={(e) => handleNotifyMe(e, 'plus')} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={user?.email || 'your@email.com'}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required={!user?.email}
                      />
                      {user?.email && (
                        <p className="text-xs text-gray-500 mt-1">
                          Using your account email: {user.email}
                        </p>
                      )}
                    </div>

                    <div className="flex items-start space-x-3 p-4 bg-blue-50 rounded-lg">
                      <input
                        type="checkbox"
                        id="newsletter"
                        defaultChecked
                        className="mt-1 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <label htmlFor="newsletter" className="text-sm text-gray-700">
                        Send me occasional updates about new features, podcasts, and learning resources. You can unsubscribe at any time.
                      </label>
                    </div>

                    <button
                      type="submit"
                      disabled={notificationLoading}
                      className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
                    >
                      {notificationLoading ? (
                        <>
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          <span>Subscribing...</span>
                        </>
                      ) : (
                        <>
                          <Mail className="w-5 h-5" />
                          <span>Notify Me for Saints Plus</span>
                        </>
                      )}
                    </button>
                  </form>

                  {/* Separate Pro notification option */}
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-600 mb-3">Also interested in advanced features?</p>
                    <button
                      onClick={(e) => handleNotifyMe(e, 'pro')}
                      disabled={notificationLoading}
                      className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
                    >
                      <Mail className="w-5 h-5" />
                      <span>Notify Me for Saints Pro</span>
                    </button>
                  </div>
                </>
              )}
            </motion.div>
          </div>

          {/* Current Free Content */}
          <div className="lg:col-span-1">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-white rounded-2xl shadow-xl p-8"
            >
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Enjoy Free Content Now</h2>
              <p className="text-gray-600 mb-6">
                While we prepare Saints Plus, explore our extensive free podcast library covering AI, technology, business, and more.
              </p>

              <div className="space-y-4">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl">
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-md">
                      <Headphones className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">130+ AI-Generated Podcasts</h3>
                      <p className="text-sm text-gray-600">Listen to cutting-edge content</p>
                    </div>
                  </div>
                  <button
                    onClick={() => navigate('/podcasts')}
                    className="w-full py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-md"
                  >
                    Browse Podcasts
                  </button>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-4 rounded-xl">
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center shadow-md">
                      <Zap className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">Curated Podcast Series</h3>
                      <p className="text-sm text-gray-600">Follow structured learning paths</p>
                    </div>
                  </div>
                  <button
                    onClick={() => navigate('/podcast-series')}
                    className="w-full py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-medium hover:from-purple-600 hover:to-pink-600 transition-all duration-200 shadow-md"
                  >
                    Explore Series
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;